import { Component, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, Input } from '@angular/core';

import { GeoServices } from '../../../services/geo.service';
import { FormComponentI } from '../../../shared/interfaces/form-component-i.interface';
import { InternalStateEvent } from '../../../shared/models/internal-state-event';
import { CustomStateAction, StateMiscArgument } from 'nm-socle-application/app/shared/models/customer-config';
import { TemplateInitService } from 'nm-socle-application/app/shared/services/template-init.service';
import { TemplateCurrentState } from 'nm-socle-application/app/shared/models/template-current-state';
import {AbstractComponent} from 'nm-socle-application/app/shared/models/abstract-component';

// TODO : mettre onPush
@Component({
    selector: 'side-text-panel',
    templateUrl: './side-text-panel.component.html',
    styleUrls: ['./side-text-panel.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class SideTextPanelComponent extends AbstractComponent implements FormComponentI {
    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    @Output() public internalStateEvent: EventEmitter<InternalStateEvent> = new EventEmitter();

    @Input() public misc:StateMiscArgument[] = [];

    @Input() public title:string;
    @Input() public desc:string;

    @Input() public btnLabel:string;
    @Input() public btnTooltip:string;
    @Input() public btnIcon:string;
    @Input() public btnAction: CustomStateAction = new CustomStateAction();

    constructor(
        public geoServices: GeoServices,
        protected _cd:ChangeDetectorRef,
        private _templateInitService: TemplateInitService,
    ) {
        super(_cd);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.markForCheck();
    }

    public onClickBtn() {
        if(this.btnAction != undefined && this.btnAction.type != undefined) {
            if(this.btnAction.type == 'changeState') {
                this._templateInitService.setCurrentState(new TemplateCurrentState({state: this.btnAction.params[0]}));
            }
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/components/side-text-panel/side-text-panel.component.ts